module.exports = require("./zgh-MA.js");